import { render } from "./ButtonLink.vue?vue&type=template&id=132d53b4"
import script from "./ButtonLink.vue?vue&type=script&lang=js"
export * from "./ButtonLink.vue?vue&type=script&lang=js"
script.render = render

export default script